import React from 'react'

const UpdateSession = () => {
    return <div>'Update Session component'</div>
}

export default React.memo(UpdateSession)
